import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { i18n, setLanguage, getStartingLocale } from './i18n/i18n';
import { createPinia } from 'pinia';
import { initializeAppInsights } from './utils/metrics';

initializeAppInsights(process.env.VUE_APP_APPINSIGHTS_INSTRUMENTATION_KEY);

// Initialize theme before anything else
const params = new URLSearchParams(window.location.search);
let theme = params.get('theme') || 'default';
if (window.location.host.includes('tmhsuite')) {
  theme = 'TMH';
} else if (window.location.host.includes('vibood')) {
  theme = 'VIBOOD';
} else if (window.location.host.includes('psypilot')) {
  theme = 'PSYPILOT';
}
document.documentElement.setAttribute('data-theme', theme);

// Set page title and favicon based on theme
function setTitleAndFavicon(theme) {
  if (theme === 'PSYPILOT') {
    document.title = 'Cuestionarios Psypilot';
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = '/psypilot-favicon.ico';
  }
}
setTitleAndFavicon(theme);

const app = createApp(App);
const pinia = createPinia();
app.use(pinia);
app.use(router);
app.use(i18n);

getStartingLocale()
  .then(setLanguage)
  .then(() => {
    app.mount('#app');
  });
